import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralCardWithIllustration from 'lumen/components/general/card-with-illustration';
import SettingsPageTemplate from 'lumen/components/settings/page-template';

<template>
  <SettingsPageTemplate
    @description={{t "settings.property_tags.subtitle"}}
    @title={{t "settings.property_tags.title"}}
  >
    <div class="grid grid-cols-3 gap-400">
      <GeneralCardWithIllustration
        @description={{t
          "settings.property_tags.organize_properties.description"
        }}
        @illustration="40x40_building-corporate"
        @title={{t "settings.property_tags.organize_properties.title"}}
      >
        <:footer>
          <div class="flex justify-end">
            <LinkTo
              @route="market.settings.property-tags.organize"
              class="prism-button prism-button--secondary"
              data-test-id="property-tags-organize-manage-button"
            >
              {{t "settings.property_tags.organize_properties.cta"}}
              <PrismIcon @name="arrow-right" @size="small" class="ml-100" />
            </LinkTo>
          </div>
        </:footer>
      </GeneralCardWithIllustration>

      <GeneralCardWithIllustration
        @description={{t "settings.property_tags.custom_tags.description"}}
        @illustration="40x40_price-tag"
        @title={{t "settings.property_tags.custom_tags.title"}}
      >
        <:footer>
          <div class="flex justify-end">
            <LinkTo
              @route="market.settings.property-tags.custom"
              class="prism-button prism-button--secondary"
              data-test-id="property-tags-custom-manage-button"
            >
              {{t "settings.property_tags.custom_tags.cta"}}
              <PrismIcon @name="arrow-right" @size="small" class="ml-100" />
            </LinkTo>
          </div>
        </:footer>
      </GeneralCardWithIllustration>
    </div>
  </SettingsPageTemplate>
</template> satisfies TOC<object>;
